// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1v5Dg","productName":"Table_productName__1nj5Z"};